import { Component, Input, Output } from 'angular-ts-decorators';
import { SwChangeWrapper } from '@core/app/scripts/classes/sw-change-wrapper';

import { isEmpty } from 'lodash';
import { Observable, Subject } from 'rxjs';

/**
 * A field which is display only but has an edit button to allow
 * the user to change the attached model
 *
 * @example
 * <sw-editable-field sw-change="callback(value)" sw-model="$ctrl.value">
 */
@Component({
  selector: 'swEditableField',
  template: require('./sw-editable-field.html').default,
  transclude: true,
})
export class SwEditableFieldComponent extends SwChangeWrapper {
  /**
   * Display value for the wrapper version
   */
  @Input() swValue;

  /**
   * String that will be displayed if no value is available. If not provided,
   * translation of 'core.unknown' will be used
   */
  @Input() placeholder: string;

  /**
   * If set to true, with only display the value
   */
  @Input() swDisabled: boolean;

  /**
   * Callback function, is called with the new value provided in `value`
   */
  @Output('&swChange') swChange: (swValue) => any;

  @Input('@swChange') swChangeAttr;

  /**
   * Sets the component to simplified, text input version
   */
  // TODO consider one way binding instead
  @Output('=?swModel') swModel: (() => any) | string;

  @Input('@swModel') swModelAttr;

  /**
   * [deprecated] Alias for sw-change
   */
  @Output() onUpdate: () => any;

  unknownText: string;
  private showField: boolean;
  private showFieldSubject: Subject<boolean>;
  public showField$: Observable<boolean>;

  isWrapper: any;
  isSaved: any;
  isError: any;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
  ) {
    'ngInject';
    super();

    this.unknownText = $translate.instant('core.unknown');
    this.showField = false;

    this.showFieldSubject = new Subject<boolean>();
    this.showField$ = this.showFieldSubject.asObservable();
  }

  $onInit() {
    this.swModel = !isEmpty(this.swModel) ? this.swModel : '';

    this.isWrapper = angular.isUndefined(this.swModelAttr) ? true : false;

    this.isSaved = true;
    this.isError = false;

    this.showFieldSubject.next(this.showField);

    if (angular.isDefined(this.placeholder)) {
      this.unknownText = this.placeholder;
    }

    if (angular.isUndefined(this.swChangeAttr)) {
      this.swChange = this.onUpdate;
    }

    this.swChange$.subscribe((value) => {
      this.update(value);
    });
  }

  toggleField() {
    this.showField = !this.showField;
    this.showFieldSubject.next(this.showField);
  }

  update(value) {
    this.showField = false;
    this.showFieldSubject.next(this.showField);

    this.isSaved = false;
    this.isError = false;

    const result = this.swChange({ value });

    if (result && angular.isFunction(result.then)) {
      return result.then(
        () => {
          this.isError = false;
          this.isSaved = true;
        },
        () => {
          this.isError = true;
          this.isSaved = true;
        },
      );
    } else {
      this.isError = false;
      this.isSaved = true;

      return this.$q.resolve();
    }
  }

  getClass() {
    if (this.isError) {
      return 'btn-danger';
    } else {
      return 'btn-primary';
    }
  }

  getLabel() {
    if (angular.isDefined(this.swValue)) {
      return this.swValue;
    }

    if (angular.isDefined(this.swModelAttr)) {
      return this.swModel;
    }

    return this.unknownText;
  }
}
